<mat-card class="dialog-card">
  <mat-card-title class="dialog-card-header">
    <mat-toolbar class="dialog-toolbar" color="accent" fxLayout="row" fxLayoutAlign="space-between center">
      <h1 class="dialog-card-title">{{ 'USERS.PROFILE_INFO_FORM.UI.POPUP_TITLE' | translate }}</h1>
      <button (click)="exit()" class="regular-round-button" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </mat-card-title>

  <mat-card-content class="dialog-card-content p-4" fxLayout="row" fxLayoutGap="20px">
    <form [formGroup]="userProfileForm" fxFlex fxLayout="column">
      <div fxFlex fxLayout="row" fxLayoutGap="20px">
        <mat-form-field class="full-width" color="accent">
          <mat-label>{{ 'USERS.PROFILE_INFO_FORM.FIRSTNAME' | translate }}</mat-label>
          <input formControlName="firstname" matInput maxlength="30" required />
        </mat-form-field>

        <mat-form-field class="full-width" color="accent">
          <mat-label>{{ 'USERS.PROFILE_INFO_FORM.LASTNAME' | translate }}</mat-label>
          <input formControlName="lastname" matInput maxlength="30" required />
        </mat-form-field>
      </div>

      <div fxFlex fxLayout="row" fxLayoutGap="20px">
        <mat-form-field class="full-width" color="accent">
          <mat-label>{{ 'USERS.PROFILE_INFO_FORM.UUID' | translate }}</mat-label>
          <input formControlName="uuid" matInput maxlength="30" />
        </mat-form-field>
        <mat-form-field class="full-width" color="accent">
          <mat-label>{{ 'USERS.PROFILE_INFO_FORM.PRIMARY_EMAIL' | translate }}</mat-label>
          <input formControlName="email" matInput maxlength="30" />
          @if (userProfileForm?.controls?.email?.invalid) {
            <mat-error>{{ 'FORM.ERROR_MESSAGE.INVALID_EMAIL' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>

      <div fxFlex fxLayout="row" fxLayoutGap="20px">
        <mat-form-field class="full-width" color="accent" fxFlex="48%">
          <mat-label>{{ 'USERS.PROFILE_INFO_FORM.PHONE_NUMBER' | translate }}</mat-label>
          <iot-platform-ui-phone-number-input formControlName="phoneNumber" maxlength="20"></iot-platform-ui-phone-number-input>
          <mat-hint align="end">{{ phoneNumber.value?.length || 0 }}/20</mat-hint>
          <mat-icon matSuffix matTooltip="{{ 'USERS.PROFILE_INFO_FORM.UI.INFO_MESSAGE.PHONE_FORMAT' | translate }}"> info_outline </mat-icon>
          @if (phoneNumber.invalid) {
            <mat-error>
              {{ 'USERS.PROFILE_INFO_FORM.UI.ERRORS.VALID_PHONE_NUMBER' | translate }}
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="full-width" color="accent">
          <mat-label>{{ 'USERS.PROFILE_INFO_FORM.SECONDARY_EMAIL' | translate }}</mat-label>
          <input formControlName="secondaryEmail" matInput maxlength="50" />
          @if (secondaryEmail.invalid) {
            <mat-error>{{ 'FORM.ERROR_MESSAGE.INVALID_EMAIL' | translate }}</mat-error>
          }
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>

  <mat-card-actions class="dialog-card-actions" fxLayout="row" fxLayoutAlign="end center">
    <button (click)="exit()" class="button-regular" mat-button>{{ 'USERS.PROFILE_INFO_FORM.UI.BUTTONS.CANCEL' | translate }}</button>
    <button (click)="save()" [disabled]="!userProfileForm.valid" class="button-regular" color="accent" mat-raised-button>
      {{ 'USERS.PROFILE_INFO_FORM.UI.BUTTONS.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
